function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    "data-name": "Icon ionic-md-search",
    d: "M14.472 13.3h-.638l-.24-.2a5.3 5.3 0 0 0 1.237-3.4 5.166 5.166 0 1 0-5.146 5.2 5.346 5.346 0 0 0 3.39-1.24l.239.2v.64l3.989 4 1.2-1.2zm-4.786 0a3.6 3.6 0 1 1 3.59-3.6 3.58 3.58 0 0 1-3.591 3.6z",
    transform: "translate(-4.5 -4.5)",
    style: {
      fill: "#7a8b99"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.1b9cf7a1c1c44ae3684e1d7ae2138d9e.svg";
export { ForwardRef as ReactComponent };